'use strict';

angular.module('invitations')
    .component('invitationCodeForm', {
        templateUrl: 'js/modules/invitations/components/code-form/template.html',
        controller: 'InvitationCodeFormController',
    });
